module.exports = __webpack_public_path__ + "img/5-6-4.1d65ac28.png";